<template>
    <div>
          <div class="fixedCode" v-if="isFixedCode">
        <vue-qr :text="Url" :size="130" class="Qrcode"></vue-qr>
      </div>
      <div class="fixedCode" v-if="isFixedgzh" >
        <img src="../assets/images/qrcode_gzh.jpg" alt="" srcset="">
      </div>
      <div class="closeFixed" @click="isclosecode" :class="isclose?'showcode':''">
          <i class="" :class="isclose?'el-icon-d-arrow-left':'el-icon-d-arrow-right'"></i>
          <!-- <i class="el-icon-d-arrow-left"></i> -->
        </div>
      <div class="fixedbox" :class="isclose?'noshowcode':''">
        <a style="margin-bottom:10px" @mouseenter="enter" @mouseleave="leave">
           <div class="fixedImg qrcode">
        </div>
        网站二维码
        </a>
        <a  @mouseenter="entera" @mouseleave="leavea">
        <div class="fixedImg goRss">
        </div>
       期刊公众号
        </a>
      </div>
       <el-backtop :class="isclose?'el-backtopa':''">
          <div class="fixedImg gotopbox">
    </div>
       </el-backtop>
    </div>
</template>
<script>
 import vueQr from 'vue-qr'
export default {
    data(){
        return{
        isFixedCode:false,
        isFixedgzh:false,
        isclose:false,
        }
    },
      components: {
      vueQr
    },
    methods:{
        enter(){
      this.isFixedCode=true
    },
    isclosecode(){
      if(this.isclose){
        this.isclose=false
      }else{
        this.isclose=true
      }
      
    },
    leave(){
      this.isFixedCode=false
    },
    entera(){
      this.isFixedgzh=true
    },
    leavea(){
      this.isFixedgzh=false
    },
    }
}
</script>
<style>
.el-backtop{
      border-radius: 0 !important;
     background: none !important;
     box-shadow:0 0 0px !important;
     right: 0 !important;
     bottom: 44px !important;
     width: 76px !important;
     height: 46px !important;
     background: #fff !important;
}
.el-backtopa{
  width: 0px !important;
}
.fixedbox{
  position: fixed;
  bottom:90px;
  right: 0px;
  width: 70px;
  height: 100px;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0px 0px 1px #868686;
  -webkit-box-shadow:0px 0px 1px #868686;
  -moz-box-shadow:0px 0px 1px #868686;
  color: #868686;
  padding: 15px 3px;
  z-index: 999;
}
.fixedCode{
  z-index: 99999;
}
.fixedbox a{
  color: #868686;
  display: inline-block;
}
.fixedImg{
  display: inline-block;
  width: 100%;
  background: url("../assets/images/arrow6.png") no-repeat;
  cursor: pointer;
}

.gotopbox{
  background-position: 2px -60px;
  height: 40px;
  width: 40px;
  margin: 3px;
}
.noshowcode{
width: 0px !important;
padding: 0 !important;
}
.showcode{
  right: 0 !important;
}
.qrcode{
  background-position: 18px 4px;
 height: 30px;
}
.goRss{
  background-position: 18px -30px;
  height: 30px;
}
.fixedCode{
      position: fixed;
    bottom: 90px;
    right: 67px;
    z-index: 9999;
    width: 130px;
    height: 130px;
}
.closeFixed{
  position: fixed;
    bottom: 185px;
    right: 76px;
    z-index: 999;
    width: 20px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #fff;
     box-shadow: 0px 0px 1px #868686;
  -webkit-box-shadow:0px 0px 1px #868686;
  -moz-box-shadow:0px 0px 1px #868686;
  cursor: pointer;
}
.fixedCode img{
  width: 100%;
  height: 100%;
}
</style>